export const residence = {
    '1': 'India',
    'India': 'India',
    '2': 'Other Country',
    'Other Country': 'Other Country'
}

export const gender = {
    1: 'Male',
    2: 'Female',
    
}